module.exports = __webpack_public_path__ + "static/media/masalatea.09835c37.jpg";